module.exports = __webpack_public_path__ + "img/menu_EXIM.0c24dab9.svg";